import React from 'react';
import CountdownTimer from './CountdownTimer';
const SpecialOffer = () => {
  return <div className="mb-16" id="special-offer" data-id="element-398">
      <div className="relative flex items-center mb-10" data-id="element-399">
        <div className="hidden md:block h-0.5 flex-grow bg-gradient-to-r from-transparent via-yellow-200 to-transparent" data-id="element-400"></div>
        <h2 className="text-4xl font-bold text-green-600 px-5 relative" data-id="element-401">
          <span className="relative z-10" data-id="element-402">Your Special Offer</span>
          <span className="absolute -bottom-2 left-0 right-0 h-3 bg-yellow-100 opacity-60 -z-0 skew-x-3" data-id="element-403"></span>
          <span className="text-red-500 text-lg ml-3 md:absolute md:-right-24 md:top-1 transform rotate-0 md:-rotate-6 inline-block font-bold animate-pulse" data-id="element-404">
            Expires Soon!
          </span>
        </h2>
        <div className="hidden md:block h-0.5 flex-grow bg-gradient-to-r from-transparent via-yellow-200 to-transparent" data-id="element-405"></div>
      </div>
      <CountdownTimer data-id="element-406" />
      <div className="bg-yellow-50 border-2 border-yellow-200 p-8 rounded-lg mb-10 shadow-lg relative overflow-hidden" data-id="element-407">
        {/* Decorative corner ribbon - desktop only */}
        <div className="hidden md:block absolute -top-1 -right-1 w-24 h-24 overflow-hidden" data-id="element-408">
          <div className="absolute top-0 right-0 transform translate-x-12 -translate-y-5 rotate-45 bg-red-500 text-white py-1 px-10 text-sm font-bold shadow-md" data-id="element-409">
            SAVE 50%
          </div>
        </div>
        <h3 className="text-3xl font-bold mb-5" data-id="element-410">Limited Time Offer:</h3>
        <div className="prose prose-xl max-w-none mb-8" data-id="element-411">
          <p className="text-xl leading-relaxed" data-id="element-412">
            MyoQuell patches should cost $100+ per month. (Cortisone shots are
            $500. Surgery is $30,000.)
          </p>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-sm mb-8 transform hover:scale-[1.02] transition-all duration-300" data-id="element-413">
          <div className="flex justify-between items-center mb-4 pb-4 border-b" data-id="element-414">
            <span className="text-xl" data-id="element-415">Regular Price:</span>
            <span className="text-xl line-through" data-id="element-416">$39.95</span>
          </div>
          <div className="flex justify-between items-center mb-4 pb-4 border-b" data-id="element-417">
            <span className="text-xl font-bold" data-id="element-418">TODAY ONLY:</span>
            <span className="text-3xl font-bold text-red-600" data-id="element-419">$19.95</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-420">
            <span className="text-xl" data-id="element-421">You Save:</span>
            <span className="text-xl text-green-600 font-bold" data-id="element-422">
              $20 (50% OFF)
            </span>
          </div>
        </div>
        <a href="https://myoquell.com/products/escape-knee-pain-with-myoquell-herbal-patches" className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white font-bold py-5 px-8 rounded-lg w-full text-2xl mb-5 block text-center shadow-lg transform hover:scale-[1.02] transition-all duration-300 animate-pulse" target="_blank" rel="noopener noreferrer" data-id="element-423">
          YES! Send Me MyoQuell Risk-Free →
        </a>
        <p className="text-center text-lg text-gray-600 font-medium flex items-center justify-center" data-id="element-424">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-425">
            <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-426" />
          </svg>
          You're protected by our 30-day guarantee. Nothing to lose but your
          pain.
        </p>
      </div>
      <div className="bg-gray-50 p-8 rounded-lg shadow-md mb-10" data-id="element-427">
        <div className="flex flex-col md:flex-row gap-10" data-id="element-428">
          <div className="md:w-1/3" data-id="element-429">
            <div className="bg-white p-6 rounded-lg shadow-sm transform hover:scale-[1.02] transition-transform duration-300" data-id="element-430">
              <h3 className="text-center font-bold mb-4 text-xl" data-id="element-431">
                Don't miss this limited-time offer
              </h3>
              <div className="flex justify-center mb-5" data-id="element-432">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hvKKg9yb1F1QEUPV7CQnhs/Untitled_design_%282%29.png" alt="MyoQuell Herbal Knee Pain Relief Patches" className="w-48 h-auto" data-id="element-433" />
              </div>
              <div className="text-center" data-id="element-434">
                <p className="text-lg mb-2" data-id="element-435">
                  Regular price: <span className="line-through" data-id="element-436">$39.95</span>
                </p>
                <p className="font-bold text-3xl text-red-600" data-id="element-437">$19.95</p>
                <p className="text-lg text-green-600 font-medium" data-id="element-438">
                  with 50% OFF discount
                </p>
              </div>
            </div>
          </div>
          <div className="md:w-2/3" data-id="element-439">
            <h3 className="text-3xl font-bold mb-5" data-id="element-440">
              The Cost of Doing Nothing
            </h3>
            <div className="prose prose-xl max-w-none" data-id="element-441">
              <p className="mb-4 text-xl leading-relaxed" data-id="element-442">
                A decent knee brace from big tool companies could cost{' '}
                <span className="font-bold" data-id="element-443">$150+</span>. Professional
                year-round doctor service could easily cost you{' '}
                <span className="font-bold" data-id="element-444">$1000 and beyond</span>!
              </p>
              <p className="mb-4 text-xl leading-relaxed" data-id="element-445">
                While MyoQuell is only a fraction of the cost of all these.
              </p>
              <p className="mb-5 text-xl leading-relaxed" data-id="element-446">
                At the moment, you can get MyoQuell for just{' '}
                <span className="font-bold" data-id="element-447">$19.95</span> with a whopping{' '}
                <span className="font-bold text-red-600" data-id="element-448">50% OFF</span>{' '}
                discount. It's an amazing deal and we're sure this won't last
                long...
              </p>
              <p className="mb-8 text-xl leading-relaxed" data-id="element-449">
                However, once the promo is over, it's only going to get more
                expensive...
              </p>
            </div>
            <a href="https://myoquell.com/products/escape-knee-pain-with-myoquell-herbal-patches" className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white font-bold py-4 px-8 rounded-lg w-full text-2xl block text-center shadow-md transform hover:scale-[1.01] transition-all duration-300" target="_blank" rel="noopener noreferrer" data-id="element-450">
              Click here to claim a discounted MyoQuell (if it's still
              available)
            </a>
          </div>
        </div>
      </div>
      <div className="mt-10 border-t pt-5 bg-gray-50 p-5 rounded-lg text-gray-500 text-base" data-id="element-451">
        <p className="mb-2 leading-relaxed" data-id="element-452">
          These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure,
          or prevent any disease. Results may vary. Not all users will
          experience the same results. Always consult with a qualified
          healthcare provider before beginning any new health program or if you
          have any questions regarding a medical condition.
        </p>
      </div>
    </div>;
};
export default SpecialOffer;